export var ActivitiesEnum;
(function (ActivitiesEnum) {
    ActivitiesEnum[ActivitiesEnum["createBattle"] = 1] = "createBattle";
    ActivitiesEnum[ActivitiesEnum["createPosition"] = 2] = "createPosition";
    ActivitiesEnum[ActivitiesEnum["claimWin"] = 3] = "claimWin";
    ActivitiesEnum[ActivitiesEnum["leaderboardWins"] = 4] = "leaderboardWins";
    ActivitiesEnum[ActivitiesEnum["deposit"] = 5] = "deposit";
    ActivitiesEnum[ActivitiesEnum["withdraw"] = 6] = "withdraw";
    ActivitiesEnum[ActivitiesEnum["claimMarketMakerIncentive"] = 7] = "claimMarketMakerIncentive";
    ActivitiesEnum[ActivitiesEnum["claimRefund"] = 8] = "claimRefund";
    ActivitiesEnum[ActivitiesEnum["updatePosition"] = 9] = "updatePosition";
})(ActivitiesEnum || (ActivitiesEnum = {}));
export var ArtistActivityType;
(function (ArtistActivityType) {
    ArtistActivityType[ArtistActivityType["Subscribers"] = 1] = "Subscribers";
    ArtistActivityType[ArtistActivityType["Followers"] = 2] = "Followers";
    ArtistActivityType[ArtistActivityType["Track_chart"] = 3] = "Track_chart";
    ArtistActivityType[ArtistActivityType["Album_chart"] = 4] = "Album_chart";
    ArtistActivityType[ArtistActivityType["Other"] = 5] = "Other";
})(ArtistActivityType || (ArtistActivityType = {}));
export var EntitiesEnum;
(function (EntitiesEnum) {
    EntitiesEnum[EntitiesEnum["battle"] = 1] = "battle";
    EntitiesEnum[EntitiesEnum["position"] = 2] = "position";
    EntitiesEnum[EntitiesEnum["claim"] = 3] = "claim";
    EntitiesEnum[EntitiesEnum["leaderboard"] = 4] = "leaderboard";
})(EntitiesEnum || (EntitiesEnum = {}));
//# sourceMappingURL=activities.enums.js.map